import React from "react";
import { AppBar, Toolbar, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import SearchBarBox from "../views/Search/SearchBar";

const useStyles = makeStyles((theme) => ({
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    marginTop: "46px",
  },
}));

const TopBar = ({ preferredName }) => {
  const classes = useStyles();

  return (
    <AppBar position="fixed" className={classes.appBar} color="primary">
      <Toolbar>
        <Typography variant="h6" noWrap style={{ flex: 1 }}>
          Teams DMV
        </Typography>
        <SearchBarBox />
        <Typography variant="h6" noWrap style={{ margin: "10px" }}>
          Welcome {preferredName}
        </Typography>
      </Toolbar>
    </AppBar>
  );
};

export default TopBar;
